import { QTableColumn } from 'pansx-utils';

export class CustomerBank {
    public id?: number;
    public bankName = '';
    public bankAccount = '';
    public valid?: boolean;

    public static of(o: unknown): CustomerBank {
        return Object.assign(new CustomerBank(), o);
    }
    public static getColumns(): QTableColumn[] {
        return [
            { name: 'id', field: 'id', label: '序号' },
            { name: 'bankName', field: 'bankName', label: '银行名称' },
            { name: 'bankAccount', field: 'bankAccount', label: '银行账户' },
            { name: 'valid', field: 'valid', label: '有效的' },
        ];
    }
    public getColumnLabel(field: string) {
        const columns = CustomerBank.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}
